import { Breakpoint, Typography } from '@altibox/design-system-component-lib';
import React, { FunctionComponent } from 'react';

import { ShoppingCart } from 'app/api/@generated/backend';

import { i18n } from 'app/i18n';
import { I18nUtils } from 'app/utils/i18n-utils';
import { useAppDispatch } from 'app/hooks/thunk-hooks';
import { changeIsExtraUnitNeededActionCreator } from 'app/pages/order/redux/action-creators/change-is-extra-unit-needed-action-creator';
import { ShoppingCartUtils } from 'app/utils/shopping-cart-utils';

import { StyledCheckbox, StyledContainer, StyledTitle } from './extra-unit-select.styled';

interface Props {
    extraUnitAdded: boolean;
    shoppingCart: ShoppingCart;
}

export const ExtraUnitSelect: FunctionComponent<Props> = (props) => {
    const { extraUnitAdded, shoppingCart } = props;
    const dispatch = useAppDispatch();
    const charge = ShoppingCartUtils.getChargeForSingleUnit(shoppingCart);

    const handleChange = (value: boolean) => {
        dispatch(changeIsExtraUnitNeededActionCreator(value));
    };

    return (
        <StyledContainer>
            <StyledTitle variant="paragraph1" component="p" maxBreakpoint={Breakpoint.TABLET}>
                {i18n.page.productDetails.buyExtraUnit.title}
            </StyledTitle>
            <Typography variant="paragraph2" component="p" maxBreakpoint={Breakpoint.TABLET}>
                {i18n.page.productDetails.buyExtraUnit.description}
            </Typography>
            <StyledCheckbox id="extraUnit" name="extraUnit" onChange={handleChange} checked={extraUnitAdded}>
                <Typography variant="paragraph2" component="div" maxBreakpoint={Breakpoint.TABLET}>
                    {I18nUtils.richMessage(i18n.page.productDetails.buyExtraUnit.checkbox, {
                        amount: charge.price,
                    })}
                </Typography>
            </StyledCheckbox>
            <Typography variant="paragraph2" component="p" maxBreakpoint={Breakpoint.TABLET}>
                {i18n.page.productDetails.buyExtraUnit.note}
            </Typography>
        </StyledContainer>
    );
};
